declare interface String {
    isNullOrEmpty(): boolean;
    startsWith(v:string):boolean;
    endsWith(v:string):boolean;
}

String.prototype.isNullOrEmpty = function () :boolean {
  if (this === undefined || this === null || this === '' || this.length === 0){
      return true;
  }
  return false;
};

String.prototype.startsWith = function(v:string):boolean {
    if (this.isNullOrEmpty()) {
        return false;
    }
    if (v.isNullOrEmpty()){
        return false;
    }
    if (this.length < v.length) {
        return false;
    }
    return this.substring(0, v.length) === v;
};